import { addDays } from "date-fns";

import type { IHotelsSearchSchema } from "../types/hotel-search-type";

export function getDefaultHotelFormValue(): IHotelsSearchSchema {
  return {
    date: {
      from: addDays(new Date(), 3),
      to: addDays(new Date(), 6),
    },
    location: {
      id: 154831,
      name: "Dubai",
      code: 121449,
      star_category: 0,
      type: "City",
      city_code: 121449,
      country_code: "AE",
      country_name: "United Arab Emirates",
    },
    rooms: [
      {
        adults: 2,
        children: 0,
        infants: 0,
        children_ages: [],
      },
    ],
  };
}

/** @deprecated Use getDefaultHotelFormValue() instead */
export const defaultHotelFormValue: IHotelsSearchSchema =
  getDefaultHotelFormValue();

